import { RedoOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Form, Input, Select, Skeleton, Tooltip, message } from "antd";
import * as EXERCISES_API from "api/services/exercises/exercises.services";
import useFindStudentExo from "hooks/useStudentExos.hook";
import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

//!COMPONENTS
import Breadcrumbs from "components/breadcrumbs";
import AppScreen from "screens/teacher/ScreenWithSidebar";

//!STYLES
import { StatusCode, TypeExercices } from "common/enums";
import AppResult from "components/appResults";
import * as appRoutes from "config/routes.config";
import { useSelector } from "react-redux";
import CardExoV2 from "../components/cardExoV2";
import HeaderComponents from "../components/headerComponents";
import TabsStudent from "../components/tabs";
import s from "./assets/styles.module.css";

const StudentExercices: FC = () => {
  //!HOOK
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const submit = useRef<any>(null);
  const { id } = useParams();
  const { exercices, loading, error, setExercices, setLoading } =
    useFindStudentExo(id!);

  const { isLoggedIn, user, isAppInMaintenance } = useSelector((state) => state.auth);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  const filterExercices: any = useCallback(async (values: any) => {
    setLoading(true);
    try {
      const response = await EXERCISES_API.teacherFilterExercices(values);
      if (response.statusCode === StatusCode.OK) {
        setExercices(response.data);
      }
    } catch (error) {
      message.error("Une erreur inconnue est survenue");
    } finally {
      setLoading(false);
    }
  }, []);

  const { Search } = Input;
  const { Option } = Select;

  const onReset = () => {
    // Reset only 'title' and 'type' fields
    form.resetFields(['title', 'type']);
    form.setFieldsValue({
      chapterId: id,
    });
    submit.current.click();
  };

  const handleChange = (e: any) => {
    if (e === "tout") {
      onReset();
    }
    else {
      submit.current.click();
    }
  };

  useEffect(() => {
    if (isAppInMaintenance) {
      navigate(appRoutes.MAINTENANCE);
    };
  }, [isAppInMaintenance]);

  return (
    <React.Fragment>
      {isMobile && isLoggedIn && <div style={{ height: user?.accountManaged !== null ? "20px" : "0px", width: "100%" }}></div>}
      {!isMobile && <Breadcrumbs isMycontent={true} />}
      <HeaderComponents />
      <TabsStudent
        textBack="Retour aux chapitres"
        onRequest={() => { }}
        onExit={() => { }}
      />
      <AppScreen>
        <Form
          layout="inline"
          name="control-hooks"
          autoComplete="off"
          onFinish={filterExercices}
          form={form}
          initialValues={{
            chapterId: id,
          }}
        >
          <div className={s.filter}>
            <div className={s.search}>
              <Form.Item name="title">
                <Search
                  onChange={() => submit.current.click()}
                  style={{ paddingTop: "3px" }}
                  bordered={false}
                  placeholder="Rechercher un exo"
                  // onSearch={onSearch}
                  enterButton={
                    <button>
                      <SearchOutlined />
                    </button>
                  }
                />
              </Form.Item>
              <Form.Item name="chapterId" initialValue={id} style={{ visibility: "hidden" }}>
                <Input
                  bordered={true}
                  style={{ fontSize: "14px" }}>
                </Input>
              </Form.Item>
            </div>

            <Tooltip placement="left" title={"Réinitialiser tous les filtres"}>
              <Button
                className={s.__reset__btn}
                onClick={onReset}
                shape="circle"
                htmlType="button"
              >
                <RedoOutlined />
              </Button>
            </Tooltip>

            <div className={s.select}>
              <Form.Item name="type">
                <Select
                  placeholder="Sélectionner un type "
                  style={{ paddingTop: "3px" }}
                  bordered={false}
                  onChange={handleChange}
                  allowClear
                >
                  <Option value={TypeExercices.ApplicationsDeCours}>
                    {TypeExercices.ApplicationsDeCours}
                  </Option>
                  {/* <Option value={TypeExercices.Classiques}>
                    {TypeExercices.Classiques}
                  </Option> */}
                  <Option value={TypeExercices.Annales}>
                    {TypeExercices.Annales}
                  </Option>
                  {/* <Option value={TypeExercices.Entraînement}>
                    {TypeExercices.Entraînement}
                  </Option> */}
                  <Option value={"tout"}>
                    {"Afficher tout"}
                  </Option>
                </Select>
              </Form.Item>
            </div>
          </div>
          <Button
            ref={submit}
            htmlType="submit"
            className={s.__submit__hidden}
          ></Button>
        </Form>

        <div className={s.main}>
          {loading && (
            <>
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </>
          )}
          {!loading && exercices.result.length <= 0 ? (
            <AppResult status="info" title="Aucun exercice disponible !" />
          ) : (
            <>
              {!loading && (
                <>
                  {exercices?.result.map((exercise: any) => (
                    <CardExoV2
                      title={exercise?.title}
                      description={exercise?.description}
                      date={exercise?.updatedAt}
                      nameChapter={exercise?.chapterId?.title}
                      level={exercise?.course?.level?.title}
                      cours={exercise?.course?.title}
                      clues={exercise?.clues[0]?.title}
                      solutions={exercise?.solutions[0]?.title}
                    // loading={loading}
                    />
                  ))}
                </>
              )}
            </>
          )}
        </div>
      </AppScreen>
    </React.Fragment>
  );
};

export default StudentExercices;
